import { createBrowserHistory } from 'history';

export const BASE_NAME = '/author/';

const history = createBrowserHistory({
    basename: BASE_NAME,
});

export default history;
